<template>
  <div class="section-container">
    <!-- Header with Add Button -->
    <b-row align-v="center" class="mb-2">
      <b-col md="12">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="text-uppercase font-weight-bold mb-0" style="display: flex; align-items: center">
            <i class="fas fa-chalkboard mr-2" style="font-size: 20px !important;"></i> Programs Attended
          </h5>
          <b-button size="sm" variant="info" @click="showAddModal">
            <i class="fas fa-plus mr-1" style="font-size: 12px !important;"></i> Add
          </b-button>
        </div>
      </b-col>
    </b-row>

    <!-- Table -->
    <b-row v-if="programs && programs.length > 0" align-v="center" class="mb-3">
      <b-col md="12">
        <table class="table table-striped table-bordered">
          <thead class="thead-dark text-left">
            <tr>
              <th>Sl No.</th>
              <th>Description</th>
              <th>Category</th>
              <th>Academic Year</th>
              <th>Period</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="program in sortedPrograms" :key="program.id">
              <td>{{ program.si_no }}</td>
              <td>{{ program.description }}</td>
              <td>{{ program.category }}</td>
              <td>{{ program.academic_year }}</td>
              <td>{{ program.period }}</td>
              <td>
                <i class="fas fa-edit pointer text-info" style="font-size: 18px !important;"
                  @click="editProgram(program)"></i>
                <i class="fas fa-trash fa-sm ml-2" style="cursor: pointer; color: #dc3545;"
                  @click="deleteProgram(program)"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>

    <!-- Modal -->
    <b-modal v-model="showModal" title="Program Attended" @hide="resetForm" hide-footer>
      <b-form @submit.prevent="createOrUpdateProgram">
        <b-form-group label="Sl No">
          <b-form-input type="number" v-model="program.si_no"></b-form-input>
        </b-form-group>
        <b-form-group label="Description">
          <b-form-input v-model="program.description"></b-form-input>
        </b-form-group>
        <b-form-group label="Category">
          <b-form-input v-model="program.category"></b-form-input>
        </b-form-group>
        <b-form-group label="Academic Year">
          <b-form-input v-model="program.academic_year"></b-form-input>
        </b-form-group>
        <b-form-group label="Period">
          <b-form-input v-model="program.period"></b-form-input>
        </b-form-group>

        <div class="text-center">
          <b-button type="submit" variant="success">
            {{ editIndex === null ? 'Add' : 'Update' }}
          </b-button>
          <b-button variant="danger" class="ml-2" @click="showModal = false">Cancel</b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["profile", "profileId"],
  data() {
    return {
      showModal: false,
      editIndex: null,
      programs: this.profile.programs || [],
      program: { si_no: "", description: "", category: "", academic_year: "", period: "" },
    };
  },
  computed: {
    sortedPrograms() {
      return [...this.programs].sort((a, b) => Number(a.si_no) - Number(b.si_no));
    }
  },
  methods: {
    async getProfile() {
      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/myprofile?profileId=${this.profileId}`;
        const response = await this.$axios.get(url);
        this.profile.programs = response.data.programs;
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    },
    async createOrUpdateProgram() {
      try {
        const url = this.$store.getters.getAPIKey.mainAPI + `/userprofiles/programs`;
        let response;

        if (this.editIndex === null) {
          // Create
          response = await this.$axios.post(url, {
            ...this.program,
            si_no: Number(this.program.si_no),
            user_profile_id: this.profile.id,
          });
          this.programs.unshift(response.data);
        } else {
          // Update
          const updateUrl = `${url}/${this.program.id}`;
          response = await this.$axios.put(updateUrl, {
            ...this.program,
            si_no: Number(this.program.si_no),
          });
          this.programs.splice(this.editIndex, 1, response.data);
        }

        this.$toast.success("Profile Updated", { position: "top", duration: 3000 });
        this.getProfile();
        this.showModal = false;
      } catch (error) {
        console.error("Error updating program:", error);
        this.$toast.error("Failed to update profile", { position: "top", duration: 3000 });
      }
    },
    showAddModal() {
      this.resetForm();
      this.showModal = true;
    },
    editProgram(program) {
      this.program = { ...program };
      this.editIndex = this.programs.findIndex(p => p.id === program.id);
      this.showModal = true;
    },
    async deleteProgram(program) {
      try {
        const deleteUrl = `${this.$store.getters.getAPIKey.mainAPI}/userprofiles/programs/${program.id}`;
        await this.$axios.delete(deleteUrl);

        const index = this.programs.findIndex(p => p.id === program.id);
        if (index !== -1) {
          this.programs.splice(index, 1);
        }
        this.getProfile();
        this.$toast.success("Program deleted", { position: "top", duration: 3000 });
      } catch (error) {
        console.error("Error deleting program:", error);
        this.$toast.error("Failed to delete program", { position: "top", duration: 3000 });
      }
    },
    resetForm() {
      this.program = { si_no: "", description: "", category: "", academic_year: "", period: "" };
      this.editIndex = null;
    }
  }
};
</script>

<style scoped>
.section-container {
  padding: 14px;
  background-color: #f9f9f9;
  border-radius: 0px;
  margin-bottom: 20px;
}
</style>
